import React from "react";

/** Keeps one page's render error inside the content column, so the sidebar
 * stays usable; resets when ``resetKey`` (the route) changes. */
export class PageBoundary extends React.Component<
  { resetKey: string; children: React.ReactNode },
  { error: Error | null; key: string }
> {
  state = { error: null as Error | null, key: this.props.resetKey };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  static getDerivedStateFromProps(
    props: { resetKey: string },
    state: { error: Error | null; key: string },
  ) {
    return props.resetKey === state.key
      ? null
      : { error: null, key: props.resetKey };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="ins-card page-error" role="alert">
        <div className="ins-title">This page hit an error</div>
        <div className="ins-sub">
          Other pages still work; reload to try again.
        </div>
      </div>
    );
  }
}
